import { Typography } from "@mui/material";
import { OLButton } from "OLButton";
import { ReactComponent as ChevronRightIcon } from "components/Icons/chevron-right.svg";
import { useMessage } from "hooks/intl";
import { kebabCase } from "lodash";
import React from "react";
import { useStyles } from "./AchievementTemplates.styles";

interface TemplateBoxProps {
  id?: number;
  badge: React.ReactElement;
  title: string;
  description: string;
  butttonLabel?: string;
  className?: string;
  onClick: () => void;
}
export function TemplateBox({
  id,
  badge,
  title,
  description,
  butttonLabel,
  className,
  onClick,
}: TemplateBoxProps) {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <div className={`${classes.templateBox} ${className}`} onClick={onClick}>
      <span className={classes.boxIcon}>{badge}</span>
      <Typography className={classes.templateTitle}>{title}</Typography>
      <Typography className={classes.templateDescription}>
        {description}
      </Typography>
      <OLButton
        className={classes.button}
        endIcon={<ChevronRightIcon />}
        data-test-id={
          butttonLabel ? kebabCase(butttonLabel) : `use-template-${id}`
        }
      >
        {message({ id: butttonLabel || "useTemplate" })}
      </OLButton>
    </div>
  );
}
